export default {
  //获取用户登录信息
  getuser: `/${PREFIX}/${PACKAGENAME}/loginsso/getuser`,
  questions: `/${PREFIX}/${PACKAGENAME}/callinterface/questions`,
  queryByGuideRule: `/${PREFIX}/${PACKAGENAME}/ybsl/queryByGuideRule`,
  annotation: `/${PREFIX}/${PACKAGENAME}/callinterface/annotation`,
  matters: `/${PREFIX}/${PACKAGENAME}/callinterface/matters`,
  getPoliceJiedao: `/${PREFIX}/${PACKAGENAME}/ybsl/getPoliceJiedao`,
  getCurXZQH: `/${PREFIX}/${PACKAGENAME}/callinterface/getCurXZQH`,
  checkYb: `/${PREFIX}/${PACKAGENAME}/ybsl/checkYb`,
  getSxForm: `/${PREFIX}/${PACKAGENAME}/ybsl/getSxForm`,
  uploadToTis: `/${PREFIX}/${PACKAGENAME}/ybsl/uploadToTis`,
  zz_download_other: `/${PREFIX}/${PACKAGENAME}/certificate/downloadother`,
  submitSx: `/${PREFIX}/${PACKAGENAME}/ybsl/submitSx`,
  deleteFileFromTis: `/${PREFIX}/${PACKAGENAME}/ybsl/deleteFileFromTis`,
  formPrint: `/${PREFIX}/${PACKAGENAME}/ybsl/formPrint`,
  judgeFile: `/${PREFIX}/${PACKAGENAME}/ybsl/judgeFile`,
  service: `/${PREFIX}/${PACKAGENAME}/callinterface/services`,
  // 主题引导申请须知以及材料清单审查要点下载接口
  filedownload: `/${PREFIX}/${PACKAGENAME}/callinterface/filedownload`,
  dictionary: `/${PREFIX}/${PACKAGENAME}/callinterface/dictionary`,
  unionprocess: `/${PREFIX}/${PACKAGENAME}/callinterface/unionprocess`,
  stat: `/${PREFIX}/${PACKAGENAME}/callinterface/stat`,
  policyFast: `/${PREFIX}/shspacelife/match/policyFast`,
  matchResultNet: `/${PREFIX}/shspacelife/query/matchResultNet`,
  encrypt: `/${PREFIX}/shspacelife/RSA/encrypt`,
  encryption: `/${PREFIX}/shspacelife/RSA/encryption`,
  declare: `/qykj/portal/workflow/apsLogin.wf`,
  qpPolicy: `/qykj/shspace/suggestproject/tuijianBySpe`,
  dictionarytwo: `/${PREFIX}/${PACKAGENAME}/callinterface/dictionary`,
};

export const devURL = PUBLICENV;
export const validateLoginURL =
  "http://zwdtuser.sh.gov.cn/uc/login/login.jsp?redirect_uri=";



// WEBPACK FOOTER //
// ./qp/assets/js/urlMapper.js